import AuthService from "../login/auth.service";
import { comprobantes } from "../../components/generico/utils/UrlAPI";
import axios from "axios";

class FacturaService {
  async obtenerListadoFacturas(mes, anio) {
    var config = {
      method: "get",
      url:
        comprobantes +
        "facturacion-electronica/listar?mes=" + mes + "&anho=" + anio,
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken(),
      },
    };
    return await axios(config);
  }

  async descagarFactura(cdc) {
    var _url = comprobantes + "facturacion-electronica/facturaPdf?cdc=" + cdc;

    var config = {
      method: "post",
      url: _url,
      responseType: "blob",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken(),
      },
    };
    return await axios(config);
  }
}
export default new FacturaService();
